import { Trans, useTranslation } from 'next-i18next';
import { LoadingImage } from '@/components/Loading';
import { cn } from '@/utils';
const AiSingleOptionGenerating = ({
  children,
  className,
  isVisible
}: {
  children: React.ReactNode;
  className?: string;
  isVisible: boolean;
}) => {
  if (!isVisible) return null;
  return <div className={cn('z-10 absolute top-0 left-0 size-full flex items-center gradient-text-shine text-heading-sm-bold', className)} data-sentry-component="AiSingleOptionGenerating" data-sentry-source-file="AiGeneratingUI.tsx">
      {children}
    </div>;
};
const AiBulkOptionsGenerating = ({
  isVisible
}: {
  isVisible: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  if (!isVisible) return null;
  return <div className="absolute z-10 flex size-full items-center justify-center gap-[12px] bg-opacity-white-6 backdrop-blur-[3px]" data-sentry-component="AiBulkOptionsGenerating" data-sentry-source-file="AiGeneratingUI.tsx">
      <LoadingImage className="size-[26px]" data-sentry-element="LoadingImage" data-sentry-source-file="AiGeneratingUI.tsx" />
      <p className="text-heading-sm-bold text-neutral opacity-[72%]">
        <Trans t={t} i18nKey="build:ai.generate.loading" components={{
        Strong: <strong className="text-strong" />
      }} data-sentry-element="Trans" data-sentry-source-file="AiGeneratingUI.tsx" />
      </p>
    </div>;
};
export const AiGeneratingUI = {
  SingleOption: AiSingleOptionGenerating,
  BulkOptions: AiBulkOptionsGenerating
};